'use client'

import React from 'react'
import type { ReactNode } from 'react'
import Card from '~/components/ui/card'
import { IconSearchSvg } from '~/icons/ic_search'

interface CardItemProps {
  title?: string
  description?: string
  onClick?: () => void
  icon?: ReactNode
  placeholder?: string
}

export default function CardItem({
  title,
  description,
  onClick,
  icon,
  placeholder,
}: CardItemProps) {
  return (
    <Card
      className="mb-4 cursor-pointer overflow-hidden"
      onClick={onClick}
      borderRadius={8}
      background="white"
    >
      <div className="flex w-full items-center justify-between gap-2">
        {icon || <IconSearchSvg />}
        <div className="w-full">
          <div className="mb-1 font-lexend text-xs font-[350] leading-4 text-[#666B74]">
            {title}
          </div>
          <div className="flex items-center gap-2 text-[12px] font-medium text-[#2D2E32]">
            <div className="flex-1">{description || placeholder}</div>
          </div>
        </div>
      </div>
    </Card>
  )
}
